import React, { Component } from 'react';
import MenuBar from '../../components/MenuBar/MenuBar';

import MapTracking from '../../components/Monitor/MapTracking/MapTracking';
import MapTrackingHistory from '../../components/Monitor/MapTrackingHistory/MapTrackingHistory';

import './menu/tab/css/tabs.css'


import './css/Monitor.css';

import {getMainCookie,checkStatus,checkPrivileges} from '../../../util/util';

import {withNamespaces } from 'react-i18next'
import DealerCustomerCard from '../../components/Monitor/DealerCustomerCard/DealerCustomerCard';
import TrackingCrad from '../../components/Monitor/TrackingCard/TrackingCrad';
import TrackingCradList from '../../components/Monitor/TrackingCradList/TrackingCradList';
import DateTimeRange from '../../components/UserControl/DateTimeRange/DateTimeRange';
import TextBoxMultiCarFilter from '../../components/UserControl/TextBoxMultiCarFilter/TextBoxMultiCarFilter';
import {Alert} from '../../Modals/AlertBar';
import $ from 'jquery';
import POIConfig  from '../../components/Monitor/POI/POIconfig';
import { TimePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import CarAlertList from '../../components/Monitor/CarAlert/CarAlertList';
import MapAlert from '../../components/Monitor/MapAlert/MapAlert';
import { Promise } from 'core-js';
import { resolve } from 'path';
import TrackDetailStatus from '../../components/Monitor/TrackDetailStatus/TrackDetailStatus';
import TrackDetailAlert from '../../components/Monitor/TrackDetailAlert/TrackDetailAlert';
import TrackDetailPOI from '../../components/Monitor/TrackDetailPOI/TrackDetailPOI';

let startHistoryDate=null;
let endHistoryDate=null;
let tagsHistory=null;
let tagsCarAlert=null;
let m_trackHistoryList=null;
let m_trackHistory2List=null;
let u;
let token //= getMainCookie().token;
let intervalAlert;
let m_carAlertNotify = false;
let m_imie_select = "-1";
class Monitor extends Component {
    constructor() {
        super();
        this.mapTracking = React.createRef();
        this.mapTrackingPoi = React.createRef();
        this.mapTrackingHistory = React.createRef();
        this.mapAlert = React.createRef();
        this.trackingCradListHistory = React.createRef();
        this.trackingCradList = React.createRef();
        this.carAlertList = React.createRef();
        this.trackDetailAlert = React.createRef();
        this.trackDetailPOI = React.createRef();
        // this.tmeHistoryStart =  React.createRef();
        // this.tmeHistoryEnd =  React.createRef();
        this.state  = {
            isShowTracking:checkPrivileges("tracking"),
            isShowTrackCardList : false,//checkPrivileges("tracking"),
            isShowTrackingHistory:false,
            isShowTrackHistoryCardList : false,
            isShowGroupList:false,
            selectHistoryDateRange:{
                                    startDate:this.getCurrentDate(new Date()),
                                    endDate:this.getCurrentDate(new Date()),
                                    startTimeHistory:"00:00",
                                    endTimeHistory:"23:50"
                                    },
            isShowPOI:false,
            isShowMapAlert:false,
            carAlertList : [],
            lonlatByMark :[],
            selectPOIByMap : "",
            isShowTackDetail: false
        };
        
    }
    componentDidMount(){
        u = getMainCookie();
        console.log("componentDidMount",u);
        token = u.token;
        this.callCheckAlert();
        intervalAlert = setInterval(this.callCheckAlert.bind(this), 30000);
        this.checkExpDate();
    }
    componentDidUpdate(){
        
    }
    componentWillUnmount(){
        console.log("componentWillUnmount");
        tagsCarAlert = null;
        if(this.mapTracking.current)
            this.mapTracking.current.clearComp();
        if(this.mapTrackingHistory.current)
            this.mapTrackingHistory.current.clearComp();
        if(this.mapAlert.current)
            this.mapAlert.current.componentWillUnmount();
        m_trackHistoryList=null;
        m_trackHistory2List=null;
        clearInterval(intervalAlert);
        this.setState({
            isShowTracking:false,
            isShowTrackCardList : false,
            isShowTrackingHistory:false,
            isShowTrackHistoryCardList : false,
            isShowPOI:false,
            selectHistoryDateRange:{
                                    startDate:this.getCurrentDate(new Date()),
                                    endDate:this.getCurrentDate(new Date()),
                                    startTimeHistory:"00:00",
                                    endTimeHistory:"23:50"
                                    },
            carAlertList : [],
            isShowMapAlert:false,
            lonlatByMark : []
        })
    }

    checkExpDate(){
        let thisCur = this;
        fetch("http://203.150.199.244/api/admin/getDuePaymentAlert", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({})
        }).then(function (response) {
            return checkStatus(response);
        }).then((data) => {
            console.log("data cc", data)
            if (data.RESULT_STATUS == "000" && data.RESULT_DATA  && data.RESULT_DATA.details.length > 0 && data.RESULT_DATA.summary.due_payment>0) {
                let exp = "";
                data.RESULT_DATA.details.map(c=>{
                    exp += "<div class='row'><div class='col-6' style='text-align:left'>&#8226; " + c.device_no + "</div><div class='col-6'><font style='color:red'>" + " ครบกำหนด "+ c.expire_date + "</font></div></div>";
                });
               
                Alert("เครื่องครบกำหนดชำระเงิน " + data.RESULT_DATA.summary.due_payment + " คัน","<div style='max-height:130px;overflow-y:auto;background-color:#f5fdff;border:1px dashed #9de0f6'>"+exp+"</div><b style='font-size:14px'>กรุณาติดต่อเจ้าหน้าที่ หากเลยกำหนดจะไม่สามารถดูข้อมูลรถได้</b>");
                
            }
        },
            (error) => {
                console.log("error", error)
                return error;
            }

        )

    }


    callCheckAlert(){
        let thisCur = this;
        fetch("http://203.150.199.244/api/report/getTrackerEventAlert", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token":token
                },
            body: JSON.stringify({ 
                "devices": tagsCarAlert, 
                "getNotify" : m_carAlertNotify, 
                "filter": "" 
            })
        }).then(function(response) {
            return checkStatus(response);
        }).then((data) =>{
            console.log("data",data,m_carAlertNotify,tagsCarAlert)
            if(!data.RESULT_DATA && data.RESULT_DATA.length==0)
                return;
            if(data.RESULT_DATA)
                thisCur.setState({carAlertList : data.RESULT_DATA[0]});
            if(data.RESULT_DATA.length>0 && data.RESULT_DATA[0].is_notify && !thisCur.state.isShowMapAlert){
                $( "#bellAlert" ).show();
                $("#alertBubble").animate({left:-140, opacity:"show"}, 500);
                $( "#bellAlert" ).addClass( "bell-shake" );
                var sound = document.getElementById("soundBell");
                
                // async ()=>{
                //     try {
                //         await sound.play();
                //         sound.onended = function() {
                //             this.pause();
                //         };
                //     } catch(err) {

                //     }
                // }

                    sound.play();
                    sound.onended = function() {
                        this.pause();
                    };
  
                
                
                setTimeout( ()=>{
                    $("#alertBubble").animate({left:-160, opacity:"hide"}, 500);
                    $( "#bellAlert" ).removeClass( "bell-shake" );
                },5000 );
               
            }else{
                $("#alertBubble").hide();
                $( "#bellAlert" ).hide();
            }
        }, 
        (error) => {
          console.log("error",error)
          return error;
        }
            
        )
        
        
    }

    getCurrentDate(today){
        //let today = new Date();
        if(today==null)
            return null;
        let dd = !today.date?today.getDate():today.date;
        let mm = today.months==undefined?today.getMonth()+1:today.months+1; //January is 0! today
        let yyyy = !today.years?today.getFullYear():today.years;
        if(dd<10) {
            dd = '0'+dd
        } 
        if(mm<10) {
            mm = '0'+mm
        } 
        return( dd + '-' +  mm+ '-' + yyyy);
    }
    showMapTrackingHistory(){
        tagsHistory = null;
        m_carAlertNotify = false;
        if(!checkPrivileges("history")){
            Alert("คุณไม่มีสิทธิ์ ดูรถย้อนหลัง","กรุณาติดต่อผู้ดูแล้วระบบ");
            return ;
        }
        this.setState({
            isShowTracking:false,
            isShowTrackCardList : false,
            isShowPOI : false,
            isShowMapAlert:false,
            isShowTrackingHistory:true,selectHistoryDateRange:{
                startDate:this.getCurrentDate(new Date()),
                endDate:this.getCurrentDate(new Date()),
                startTimeHistory:"00:00",
                endTimeHistory:"23:50"
                },
            // isShowTrackHistoryCardList : true
        })
    }

    showMapTracking(){
        m_carAlertNotify = false;
        if(!checkPrivileges("tracking")){
            this.setState({
                isShowTracking:false,
                isShowTrackCardList : false
            });
            Alert("คุณไม่มีสิทธิ์ ดูรถปัจจุบัน","กรุณาติดต่อผู้ดูแล้วระบบ");
            return ;
        }
        this.setState({
            isShowTracking:true,
            isShowTrackCardList : true,
            isShowTrackingHistory:false,
            isShowTrackHistoryCardList : false,
            isShowPOI : false,
            isShowMapAlert:false,
        })
    }
    showPOI(){
        m_carAlertNotify = false;
        this.setState({
            isShowTracking:false,
            isShowTrackCardList : false,
            isShowTrackingHistory:false,
            isShowTrackHistoryCardList : false,
            isShowPOI:true,
            isShowMapAlert:false,
        })
    }
    showCarAlert(){
        m_carAlertNotify = true;
        this.setState({
            isShowTracking:false,
            isShowTrackCardList : false,
            isShowTrackingHistory:false,
            isShowTrackHistoryCardList : false,
            isShowPOI:false,
            isShowMapAlert:true,
        })
        this.callCheckAlert(m_carAlertNotify);
        $("#alertBubble").hide();
        $( "#bellAlert" ).hide();

    }
    setRangeDate(sDate,eDate){
        startHistoryDate=sDate;
        endHistoryDate=eDate;
        if(sDate && eDate && sDate!=null && eDate!=null){
            startHistoryDate=sDate.toObject();
            endHistoryDate=eDate.toObject();
        }
        console.log("setRangeDate",startHistoryDate,endHistoryDate);
    }
    setMultiCar(tags){
        tagsHistory = tags;
        console.log("tag",tags);
        if(this.state.isShowTracking && this.mapTracking.current != null)
            this.mapTracking.current.searchCarTrack(tags,this.state.isShowGroupList);
    }
    handleGetTrackHistoryComplete(trackHistoryList){
        console.log("trackHistoryList",trackHistoryList);
        m_trackHistoryList = trackHistoryList;
        if(trackHistoryList.tracker.length>0){
            this.setState({
                trackHistoryList : m_trackHistoryList,
                isShowTrackCardList : false,
                isShowTrackHistoryCardList : true
            })
        }
        
    }

    handleGetTrackHistory2Complete(trackHistory2List){
        console.log("trackHistory2List",trackHistory2List,m_trackHistoryList.tracker.length)
        m_trackHistory2List = trackHistory2List;
        if(trackHistory2List.tracker.length>0 && m_trackHistoryList.tracker.length==0){
            this.setState({
                trackHistoryList : m_trackHistory2List,
                isShowTrackCardList : false,
                isShowTrackHistoryCardList : true
            })
        }
    }

    handleCarHistorySelect(n){
        this.mapTrackingHistory.current.zoomExtent(n);
        if(n==1 && m_trackHistoryList.tracker.length>0){
            this.setState({
                trackHistoryList : m_trackHistoryList,
                isShowTrackCardList : false,
                isShowTrackHistoryCardList : true
            })
        }else if(n==2 && m_trackHistory2List.tracker.length>0){
            this.setState({
                trackHistoryList : m_trackHistory2List,
                isShowTrackCardList : false,
                isShowTrackHistoryCardList : true
            })
        }
    }

    handleGetTrackComplete(trackList){
        console.log("trackList",trackList);
        let t = trackList.filter(function(t) {
            return t.imei == m_imie_select;
        });
        
        if(this.state.isShowTackDetail == true && this.trackDetailAlert.current && this.trackDetailPOI.current){
            if(t[0]){
                this.trackDetailAlert.current.callCheckAlert(t[0].device_info.device_id);
                this.trackDetailPOI.current.callNearPOI(t[0].latitude,t[0].longitude);
            }
                
        }
        console.log("cc 11",t[0]);
        this.setState({
            trackList : trackList,
            isShowTrackCardList : true,
            isShowTrackHistoryCardList : false,
            lonlatByMark : [],
            trackListSelect: t[0]
        })
    }
    getSummaryTrack(imei){
        fetch("http://203.150.199.244/api/report/getPlayback", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token":token
                },
            body: JSON.stringify(
            {
                imei:imei,
                start_date : this.getCurrentDate(new Date()),
                start_time : "00:01",
                end_date : this.getCurrentDate(new Date()),
                end_time : "23:59",
                ignore_tracker:true
            })
        }).then(res => res.json())
        .then(
            (data) => {
            
            console.log("setSummaryTrack",data.RESULT_DATA)
            if(this.mapTracking.current != null)
                this.mapTracking.current.setTarckSummary(data.RESULT_DATA,imei,moment().format("DD-MM-YYYY HH:mm"));
            },
            (error) => {

            }
        );
    }
    handleCardSelect(index,device_no,lat,lng){
        
        if(this.state.isShowTrackCardList){
            
            this.mapTracking.current.zoomTo(index,lat,lng);
            this.getSummaryTrack(this.state.trackList[index].imei);
            m_imie_select = this.state.trackList[index].imei;

           
            
            console.log("cc",this.state.trackList[index])
            this.setState({
                isShowTackDetail: true,
                trackListSelect: this.state.trackList[index]
            }, () => {
                if(this.trackDetailAlert.current)
                    this.trackDetailAlert.current.callCheckAlert(this.state.trackList[index].device_info.device_id);
                if(this.trackDetailPOI.current)
                    this.trackDetailPOI.current.callNearPOI(this.state.trackList[index].latitude,this.state.trackList[index].longitude);
            })
        } 
        else
            this.mapTrackingHistory.current.zoomTo(index,lat,lng);
    }
    handleCardGroupSelect(){
        //this.mapTracking.current.searchIsGroup(this.state.isShowGroupList);
    }
    handleCarSelectIndex(index){
        if(this.state.isShowTrackingHistory && this.trackingCradListHistory.current!=null)
            this.trackingCradListHistory.current.setCarSelect(index);
        else if(this.state.isShowTracking && this.trackingCradList.current!=null)
            this.trackingCradList.current.setCarSelect(index);
    }
    handleCarSelectImei(imei){
        
        if(this.state.isShowTracking && this.trackingCradList.current!=null){
            this.getSummaryTrack(imei);
            this.trackingCradList.current.setCarSelectImei(imei);
            m_imie_select = imei;
            let t = this.state.trackList.filter(function(t) {
                return t.imei == m_imie_select;
            });
                
            
            
            console.log("cc",t[0]);
            this.setState({
                isShowTackDetail: true,
                trackListSelect: t[0]
            }, () => {
                if(this.trackDetailAlert.current && t[0])
                    this.trackDetailAlert.current.callCheckAlert(t[0].device_info.device_id);
                if(this.trackDetailPOI.current && t[0])
                    this.trackDetailPOI.current.callNearPOI(t[0].latitude,t[0].longitude);
            })
        }
            
        
    }
    handleChkGroupChange(e){
        console.log(e.target.checked);
        this.state.isShowGroupList = e.target.checked;
        if(this.state.isShowTracking && this.mapTracking.current != null)
            this.mapTracking.current.searchIsGroup(e.target.checked);
        if( this.trackingCradList.current != null)
            this.trackingCradList.current.setGroup(e.target.checked);
    }
    btnSearchHistoryClick(){
        console.log("btnSearchHistoryClick",this.getCurrentDate( startHistoryDate),this.state.selectHistoryDateRange.startTimeHistory,this.state.selectHistoryDateRange.endTimeHistory,tagsHistory);
        if(startHistoryDate==null || endHistoryDate==null || this.state.selectHistoryDateRange.startTimeHistory==""  || this.state.selectHistoryDateRange.endTimeHistory=="" || tagsHistory==null || tagsHistory.length==0)
            Alert("กรุณาใส่ข้อมูล","วัน เวลา และรถที่ต้องการดูย้อนหลัง");
        else{
            let stime = this.state.selectHistoryDateRange.startTimeHistory;
            let etime = this.state.selectHistoryDateRange.endTimeHistory;
            let start = this.getCurrentDate(startHistoryDate);
            let end = this.getCurrentDate(endHistoryDate)
            let dd=this.getCurrentDate(startHistoryDate).split("-")[0];
            let mm=this.getCurrentDate(startHistoryDate).split("-")[1];
            let yyyy=this.getCurrentDate(startHistoryDate).split("-")[2];
            start = dd + "-" + mm + "-" + yyyy;
            dd=this.getCurrentDate(endHistoryDate).split("-")[0];
            mm=this.getCurrentDate(endHistoryDate).split("-")[1];
            yyyy=this.getCurrentDate(endHistoryDate).split("-")[2];
            end = dd + "-" + mm + "-" + yyyy;
            
            this.mapTrackingHistory.current.setMapTrackingHistory(stime,start,etime,end,tagsHistory);
        }
            
    }
    handleStartTimeHistoryChange(value){
        this.state.selectHistoryDateRange.startTimeHistory = value.format('HH')+":"+value.format('mm');
    }
    handleEndTimeHistoryChange(value){
        this.state.selectHistoryDateRange.endTimeHistory = value.format('HH')+":"+value.format('mm');
    }

    handleCarAlertSelect(index,lat,long,text,symbolId,symbolColor){
        this.mapAlert.current.zoomTo(index,lat,long,text,symbolId,symbolColor);
    }
    setMultiCarAlert(tags){
        tagsCarAlert = tags;
        this.callCheckAlert();
    }
    handlePopupAlert(){
        this.carAlertList.current.setChk();
    }
    handlePOIMark(lonLat){
        this.setState({lonlatByMark : lonLat})
    }
    handleClickUpdatePOI(isUpdate){
        if(this.mapTracking.current!=null)
            this.mapTracking.current.setUpdatePOI(isUpdate);
    }
    handleSetVisiblePOILayer(isVisible){
        if(this.mapTracking.current!=null)
            this.mapTracking.current.setVisiblePOILayer(isVisible);
    }
    handleSetVisiblePOIName(isVisible){
        console.log("aa",isVisible)
        if(this.mapTracking.current!=null)
            this.mapTracking.current.setVisiblePOIName(isVisible);
    }
    handleRefreshPOI(){
        if(this.mapTracking.current!=null)
            this.mapTracking.current.refreshPOI();
    }
    handleZoomToLatLong(lat,long){
        if(this.mapTracking.current!=null)
            this.mapTracking.current.zoomToLatLong(lat,long);
    }
    handleSelectPOIMap(poi_id){
        this.setState({selectPOIByMap : poi_id});
    }
    handleMarkPointClick(){
        this.onShowMapClick();
    }
    onShowMapClick(){
        $("#monitorLeftPanel").removeClass("show");
        $("#monitorLeftPanel").addClass("hide-xs");
        $("#pnlMonitorMap").removeClass("hide-xs");
        $("#pnlMonitorMap").addClass("show");
        if(this.mapTracking.current)
            this.mapTracking.current.updateMapSize();
        if(this.mapTrackingHistory.current)
            this.mapTrackingHistory.current.updateMapSize();
        if(this.mapAlert.current)
            this.mapAlert.current.updateMapSize();
    }
    
    onShowTrackClick(){
        $("#monitorLeftPanel").removeClass("hide");
        $("#monitorLeftPanel").removeClass("hide-xs");
        $("#monitorLeftPanel").addClass("show");
        $("#pnlMonitorMap").removeClass("show");
        $("#pnlMonitorMap").addClass("hide-xs");
    }
    render() {
        
        const {t}=this.props;
        const {selectHistoryDateRange,isShowTackDetail} =this.state;
        
            

        return (
            <div>
                <audio id="soundBell" src="./sound/bell.mp3" preload="auto"></audio>
                <MenuBar tab_monitor="active"/>
                <div className=" monitor">
                <div className="row">
                    <div className="col-lg-4 col-md-5 col-sm-12 col-xd-12 monitor-main-left-panel ">
                        <div id ="monitorDealerListMini" style={{display:'none'}}>
                            <div className="col-12 gray-panel d-block d-md-none">
                                <DealerCustomerCard />
                            </div>
                        </div>
                        <div id ="monitorLeftPanel" className="show-sm">
                            <nav>
                                <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                                    <a className="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true" onClick={this.showMapTracking.bind(this)}>ปัจจุบัน</a>
                                    <a className="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false"  onClick={this.showMapTrackingHistory.bind(this)}>ย้อนหลัง</a>
                                    <a className="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false" onClick={this.showPOI.bind(this)}>จุดสนใจ</a>
                                    <a className="nav-item nav-link" id="nav-about-tab" data-toggle="tab" href="#nav-about" role="tab" aria-controls="nav-about" aria-selected="false" onClick={this.showCarAlert.bind(this)}>
                                        <div  style={{position:"relative"}}>
                                            <div id="alertBubble" className="talk-bubble tri-right round right-in" style={{display:"none"}}>
                                                <div className="talktext">
                                                    <p>มีการแจ้งเตือนใหม่</p>
                                                </div>
                                            </div>
                                        </div>
                                        แจ้งเตือน 
                                        <div style={{position:'relative'}}>                                      
                                            <i id="bellAlert" className="fas fa-bell bell-alert" ></i>
                                        </div>
                                    </a>
                                </div>
                            </nav>
                            <div className="panel-rightheading show-xs " onClick={this.onShowMapClick.bind(this)}>
                                <i className="fas fa-map-marked-alt"></i>
                                <span className="panel-righttitle">แผนที่</span>
                            </div>
                            <div className="tab-content " id="nav-tabContent" >
                                <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab" >
                                        {
                                        this.state.isShowTrackCardList &&   
                                        <div>
                                            <div className="row" style={{marginBottom:5}}> 
                                                <div className="col-8">
                                                <i className="fas fa-shipping-fast icon-for-calendar" style={{fontSize:20}}/>
                                                <div style={{display:"inline-block"}}>
                                                    <TextBoxMultiCarFilter limitSelect={10} onChange={this.setMultiCar.bind(this)}/>
                                                </div>
                                                </div>
                                                <div className="col-4 ">
                                                    <div className="pull-right">
                                                        <label className="switch">
                                                            <input type="checkbox" onChange={this.handleChkGroupChange.bind(this)}/>
                                                            <span className="slider"></span>
                                                            
                                                        </label>
                                                        <span style={{position:"relative"}}>กลุ่ม</span>
                                                    </div>
                                                
                                                </div>
                                            </div> 


                                            
                                            <div className="row" style={{alignContent: "baseline",overflowY: "auto"}}>
                                                
                                                <TrackingCradList ref={this.trackingCradList} trackList = {this.state.trackList} 
                                                onSelect = {this.handleCardSelect.bind(this)}
                                                isGroupOrder = {this.state.isShowGroupList} 
                                                isShowTackDetail = {isShowTackDetail}
                                                onMarkPointClick = {this.handleMarkPointClick.bind(this)}
                                                // onCardGroupSelect ={this.handleCardGroupSelect.bind(this)}
                                                />
                                            </div>
                                            {
                                                isShowTackDetail &&
                                                <div className="row shadow detail-status" style={{paddingBottom:3}}>
                                                    
                                                    <div className="nav nav-tabs" style={{height:40}}>
                                                       
                                                            <a className="nav-item nav-link active" data-toggle="tab" href="#trackDetailStatus" >
                                                                <i class="fas fa-info-circle"></i>สถานะ
                                                            </a>
                                                       
                                                            <a className="nav-item nav-link" data-toggle="tab" href="#trackDetailAlert">
                                                                <i class="fas fa-bell"></i>แจ้งเตือน
                                                            </a>
                                                      
                                                            <a className="nav-item nav-link" data-toggle="tab" href="#trackDetailPoi">
                                                                <i class="fas fa-map-marker"></i>ระยะPOI
                                                            </a>
                                                     
                                                    </div>
                                                    <i className="far fa-times-circle close-tab" onClick={(e)=>{
                                                        this.setState({isShowTackDetail:false});
                                                        this.mapTracking.current.clearSelectCar();}} ></i>
                                                    <div className="tab-content" style={{display:"contents"}}>
                                                        <div className="tab-pane active track-detail shadow" id="trackDetailStatus" >
                                                            <TrackDetailStatus
                                                                trackListSelect = {this.state.trackListSelect}
                                                            ></TrackDetailStatus>
                                                        </div>
                                                        <div className="tab-pane fade track-detail shadow" id="trackDetailAlert">
                                                            <TrackDetailAlert ref={this.trackDetailAlert}>
                                                            
                                                            </TrackDetailAlert>
                                                        </div>
                                                        <div className="tab-pane fade track-detail shadow" id="trackDetailPoi">
                                                            <TrackDetailPOI ref={this.trackDetailPOI}>
                                                            
                                                            </TrackDetailPOI>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            }
                                            
                                        </div>
                                        }
                                </div>   
                                
                                <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab" >
                                {
                                    this.state.isShowTrackingHistory && 
                                    <div>
                                    <div className="row">
                                        <i className="fas fa-history icon-for-calendar" />
                                        {/* <input className="form-control form-control-sm timeHistory" style={{width:65,height:34}} ref={this.tmeHistoryStart} type="time" defaultValue={"00:00:00"}/> */}
                                        <TimePicker className="timeHistory" onChange={this.handleStartTimeHistoryChange.bind(this)} minuteStep={10} defaultValue={moment('00:00', 'HH:mm')} format={'HH:mm'} />
                                        <div className="">
                                            <DateTimeRange onSelectDate={this.setRangeDate.bind(this)} isBack  small={true}
                                                // initialStartDate={selectHistoryDateRange.startDate}
                                                // initialEndDate={selectHistoryDateRange.endDate}
                                            />
                                        </div>
                                        <TimePicker className="timeHistory" onChange={this.handleEndTimeHistoryChange.bind(this)} minuteStep={10} defaultValue={moment('23:50', 'HH:mm')} format={'HH:mm'} />
                                        {/* <input className="form-control form-control-sm timeHistory" style={{width:65,height:34}} ref={this.tmeHistoryEnd} type="time"  defaultValue={"23:59:00"}/> */}
                                    </div>

                                    <div className="row" style={{marginTop:3,marginBottom:3}}>
                                    
                                        <i className="fas fa-shipping-fast icon-for-calendar" style={{fontSize:20}}/>
                                        <TextBoxMultiCarFilter limitSelect={2} onChange={this.setMultiCar.bind(this)}/>
                                        <i className="fas fa-search-location btnSearch" onClick={this.btnSearchHistoryClick.bind(this)}></i>
                                    
                                        
                                    </div>
                                    <div className="row">
                                        {
                                            this.state.isShowTrackHistoryCardList &&
                                            <TrackingCradList ref={this.trackingCradListHistory} trackHistoryList = {this.state.trackHistoryList} 
                                            onSelect = {this.handleCardSelect.bind(this)}
                                            onMarkPointClick = {this.handleMarkPointClick.bind(this)}
                                            />
                                        }
                                        
                                    </div>
                                    </div>
                                }
                                            
                                            
                                    
                                </div>
                                <div className="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                    
                                    { this.state.isShowPOI && 

                                        <POIConfig token={token} 
                                        lonlatByMark={this.state.lonlatByMark}
                                        onClickUpdatePOI = {this.handleClickUpdatePOI.bind(this)}
                                        onSetVisiblePOILayer = {this.handleSetVisiblePOILayer.bind(this)}
                                        onSetVisiblePOIName = {this.handleSetVisiblePOIName.bind(this)}
                                        onRefreshPOI={this.handleRefreshPOI.bind(this)}
                                        onZoomToLatLong={this.handleZoomToLatLong.bind(this)}
                                        selectPOIByMap = {this.state.selectPOIByMap}/>
                                    }
                                </div>
                                <div className="tab-pane fade" id="nav-about" role="tabpanel" aria-labelledby="nav-about-tab">
                                    <div className="row" style={{marginBottom:3}}>
                                        <div className="col-8">
                                            <i className="fas fa-shipping-fast icon-for-calendar" style={{fontSize:20}}/>
                                            <TextBoxMultiCarFilter limitSelect={10} onChange={this.setMultiCarAlert.bind(this)}/>
                                        </div>
                                        <div className="col-4">
                                            <button type="button" class="btn btn-primary btn-sm pull-right " onClick={this.handlePopupAlert.bind(this)} data-title="save" data-toggle="modal" data-target="#save">
                                            <i class="far fa-bell"></i> ตั้งค่าแจ้งเตือน</button>
                                        </div>
                                    </div>
                                    { this.state.isShowMapAlert && 
                                        <CarAlertList ref={this.carAlertList}  onSelect = {this.handleCarAlertSelect.bind(this)} carAlertList={this.state.carAlertList}/>
                                    }
                                </div>
                            </div>
                        </div>

                    
                    </div>
                    
                     <div id ="monitorMap" className="col-lg-8 col-md-7 " >
                        <div id ="monitorDealerList" style={{display:'none'}}>
                            <div className="col-12 gray-panel d-none d-md-block" >
                                <DealerCustomerCard />
                            </div>
                        </div>
                        <div  className="col-12 hide-xs show-sm gray-panel" id="pnlMonitorMap" >
                            <div className="panel-leftheading show-xs "  onClick={this.onShowTrackClick.bind(this)}>
                                <i className="fas fa-list"></i>
                                <span className="panel-lefttitle">รายการ</span>
                            </div>
                            
                            {
                                (this.state.isShowTracking || this.state.isShowPOI) &&
                                <MapTracking ref={this.mapTracking}  
                                onGetTrackComplete ={this.handleGetTrackComplete.bind(this)} 
                                onSelectCarImei = {this.handleCarSelectImei.bind(this)}
                                onSelectCarIndex = {this.handleCarSelectIndex.bind(this)}

                                trackList = {this.state.trackList}
                                isGroupOrder = {this.state.isShowGroupList}

                                onPOIMark = {this.handlePOIMark.bind(this)}
                                onSelectPOIMap = {this.handleSelectPOIMap.bind(this)}
                                />

                                
                            }
                            {
                                this.state.isShowTrackingHistory &&
                                <MapTrackingHistory ref={this.mapTrackingHistory} 
                                onGetTrackHistoryComplete ={this.handleGetTrackHistoryComplete.bind(this)}
                                onGetTrackHistory2Complete ={this.handleGetTrackHistory2Complete.bind(this)}
                                onSelectCarIndex = {this.handleCarSelectIndex.bind(this)}
                                onCarHistorySelect = {this.handleCarHistorySelect.bind(this)}
                                
                                trackHistory = {this.state.trackHistoryList}/>
                            }
                            {
                                this.state.isShowMapAlert &&
                                <MapAlert ref={this.mapAlert} 
                                />
                            }
                            {/* { this.state.isShowPOI && 

                                <MapTracking ref={this.mapTrackingPoi}  
                                onGetTrackComplete ={this.handleGetTrackComplete.bind(this)} 
                                onSelectCarImei = {this.handleCarSelectImei.bind(this)}
                                onSelectCarIndex = {this.handleCarSelectIndex.bind(this)}

                                trackList = {this.state.trackList}
                                isGroupOrder = {this.state.isShowGroupList}

                                onPOIMark = {this.handlePOIMark.bind(this)}
                                onSelectPOIMap = {this.handleSelectPOIMap.bind(this)}
                                />
                            } */}
                            
                        </div>
                    </div>
                    
                    
                    </div>
                </div>
            </div>
        )
    }
}
export default withNamespaces('Monitor')(Monitor);



// WEBPACK FOOTER //
// ./src/app/view/containers/Monitor/Monitor.js